export default "/images/vendor/flag-icons/flags/4x3/mf.svg?9284dddffc0b6717ee5fd113cfe2aad8";